export default __webpack_public_path__ + "static/port6-f0dcbebb3ad0a59924b77926ab03bba4.jpg";